import { render } from "./BuyCoffee.vue?vue&type=template&id=ec180b3e&scoped=true"
import script from "./BuyCoffee.vue?vue&type=script&lang=js"
export * from "./BuyCoffee.vue?vue&type=script&lang=js"

import "./BuyCoffee.vue?vue&type=style&index=0&id=ec180b3e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\alvar\\OneDrive\\Kaggle\\Vue\\pro_vouchers\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec180b3e"]])

export default __exports__